import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { DataSheetGrid } from 'react-datasheet-grid';
import { ProgramasService } from '../../services/programas.service';
import { Pais } from '../../models/pais.model';
import { Programa } from '../../models/programas.model';
import { PaisesService } from '../../services/paises.service';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { ObrasService } from '../../services/obras.service';
import ObraFilter from '../../models/obraFilter.model';
import { ObraApp } from '../../models/obraApp.model';
import { TipoObrasService } from '../../services/tipoObras.service';
import TipoObra from '../../models/tipoObra.model';
import { JefeEquiposService } from '../../services/jefeEquipos.service';
import JefeEquipo from '../../models/jefeEquipo.model';
import { MonedasService } from '../../services/monedas.service';
import Moneda from '../../models/moneda.model';
import { EstadosEjecucionService } from '../../services/estadosEjecucion.service';
import EstadoEjecucion from '../../models/estadoEjecucion.model';
import { Link } from 'react-router-dom';

import ReactDataGrid from 'react-data-grid';
import { useParams } from 'react-router-dom';
import { NotificationsService } from '../../services/notifications.service';
import { NotificationAlert } from '../../models/notifications.model';
import { General } from '../../services/general';
import { ObraAppTemporal } from '../../models/obraAppTemporal.model';
import { FormulasCreateProgram } from './formulasCreate-Program';
import Loading from '../shared/loading/Loading.component';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import { formateDate } from '../detail-program-notification/detail-program-notification';

const formulas = FormulasCreateProgram();
const moment = require('moment');
export const onChangeFuntions = (item: ObraApp) => {
    const montoContractualDolares = formulas.getMontoContractualDolares(item);
    item.montoContractualDolares = montoContractualDolares;
    const montoContractualEnDolaresMillones = formulas.getMontoContractualEnDolaresMillones(item);
    item.montoContractualDolaresEnMillones = montoContractualEnDolaresMillones;
    const montoContractualVigenteModificadoDolares =
        formulas.getMontoContractualVigenteModificadoDolares(item);
    item.montoContractualVigenteModificadoDolares = montoContractualVigenteModificadoDolares;
    const montoContractualVigenteModificadoDolaresEnMillones =
        formulas.getMontoContractualVigenteModificadoDolaresEnMillones(item);
    item.montoContractualVigenteModificadoDolaresEnMillones =
        montoContractualVigenteModificadoDolaresEnMillones;
    const totalPagoHastaLaFechaDolares = formulas.getTotalPagoHastaLaFechaDolares(item);
    item.totalPagoHastaLaFechaDolares = totalPagoHastaLaFechaDolares;
    const clasificacionporkm = formulas.getClasificacionporkm(item);
    item.clasificacionPorKm = clasificacionporkm;
    const clasificacionPorMontos = formulas.getClasificacionPorMontos(item);
    item.clasificacionPorMontos = clasificacionPorMontos;
    const precioInicialPorKmMillones = formulas.getPrecioInicialPorKmMillones(item);
    item.precioInicialPorKmMillones = precioInicialPorKmMillones;
    const precioVigentePorKmMillones = formulas.getPrecioVigentePorKmMillones(item);
    item.precioVigentePorKmMillones = precioVigentePorKmMillones;
    const clasificacionPorPlazo = formulas.getClasificacionPorPlazo(item);
    item.clasificacionPorPlazo = clasificacionPorPlazo!;
    const sobreplazoCalculadoMeses = formulas.getSobreplazoCalculadoMeses(item);
    item.sobreplazoMesesCalculado = sobreplazoCalculadoMeses.toString();
    const clasificacionPorSobreplazo = formulas.getClasificacionPorSobreplazo(item);
    item.clasificacionPorSobreplazo = clasificacionPorSobreplazo;
    const avancePlazoPlazoIntermedio = formulas.getAvancePlazoPlazoIntermedio(item);
    item.avanceDePlazoPlazoIntermedio = avancePlazoPlazoIntermedio;
    const porcentajeAvancePlazo = formulas.getPorcentajeAvancePlazo(item);
    item.porcentajeAvanceDePlazo = porcentajeAvancePlazo;
    const estadoAvanceGeneral = formulas.getEstadoAvanceGeneral(item);
    item.estadoDeAvanceGeneral = estadoAvanceGeneral!;
    const porcentajeAvanceAcumulado = formulas.getPorcentajeAvanceAcumulado(item);
    item.porcentajeAvanceAcumulado = porcentajeAvanceAcumulado;
    const plazoContractualVigentePasoIntermedio =
        formulas.getPlazoContractualVigentePasoIntermedio(item);
    item.plazoContractualVigentePasoIntermedio = plazoContractualVigentePasoIntermedio;
    const plazoContractualVigente = formulas.getPlazoContractualVigente(item);
    item.plazoContractualVigente = plazoContractualVigente;
    const sobrecostosMaterializados = formulas.getSobrecostosMaterializados(item);
    item.sobrecostosMaterializados = sobrecostosMaterializados;
    const clasificaciónSobrecostos = formulas.getClasificaciónSobrecostos(item);
    item.clasificacionDeSobrecostos = clasificaciónSobrecostos!;
    const plazoInicialKm = formulas.getPlazoInicialKm(item);
    item.plazoInicialPorKm = plazoInicialKm;
    const plazoVigenteKm = formulas.getPlazoVigenteKm(item);
    item.plazoVigentePorKm = plazoVigenteKm;
    const añoFinalizacionContratos = formulas.getAñoFinalizacionContratos(item);
    item.anoFinalizaciónContrato = añoFinalizacionContratos;
    const _2020 = formulas.get2020(item);
    item._2020 = _2020;
    const _2021 = formulas.get2021(item);
    item._2021 = _2021;
    const _2022 = formulas.get2022(item);
    item._2022 = _2022;
    const _2023 = formulas.get2023(item);
    item._2023 = _2023;
    const _2024 = formulas.get2024(item);
    item._2024 = _2024;
    const _2025 = formulas.get2025(item);
    item._2025 = _2025;
    const notaFinalSobrecostos = formulas.getNotaFinalSobrecostos(item);
    item.notaFinalSobrecostos = notaFinalSobrecostos;
    const notaFinalSobreplazo = formulas.getNotaFinalSobreplazo(item);
    item.notaFinalSobreplazo = notaFinalSobreplazo;
    const notaFinalEstadoGeneral = formulas.getNotaFinalEstadoGeneral(item);
    item.notaFinalEstadoGeneral = notaFinalEstadoGeneral;
    const subRegion = formulas.getSubRegion(item);
    item.subRegion = subRegion;
    const sobrecostosUSD = formulas.getSobrecostosUSD(item);
    item.sobrecostosUsd = sobrecostosUSD;
    const sobrecostosUSDEnMillones = formulas.getSobrecostosUSDEnMillones(item);
    item.sobrecostosUsdenMillones = sobrecostosUSDEnMillones;
    const ficMetodologicoContratosActivos = formulas.getFICMetodologicoContratosActivos(item);
    item.ficmetodologicoContratosActivos = ficMetodologicoContratosActivos;
    formulas.getFPCMetodologicoContratosActivos(item);
    const ficMetodologicoContratosActivosSinCEROS =
        formulas.getFICMetodologicoContratosActivosSinCEROS(item);
    item.ficmetodologicoContratosActivosSinCeros = ficMetodologicoContratosActivosSinCEROS;
    const fpcMetodologicoContratosActivosSinCEROS =
        formulas.getFPCMetodologicoContratosActivosSinCEROS(item);
    item.fpcmetodologicoContratosActivosSinCeros =
        fpcMetodologicoContratosActivosSinCEROS.toString();
    const ponderadorFICMCA = formulas.getPonderadorFICMCA(item);
    item.ponderadorFicMca = ponderadorFICMCA;
    const ponderadorFICMCASinCEROS = formulas.getPonderadorFICMCASinCEROS(item);
    item.ponderadorFicMcasinCeros = ponderadorFICMCASinCEROS;
    const ponderadorPFCMCASinCEROS = formulas.getPonderadorPFCMCASinCEROS(item);
    item.ponderadorPfcMcasinCeros = ponderadorPFCMCASinCEROS.toString();
    const fechaOrdenInicioEnMesAño = formulas.getFechaOrdenInicioEnMesAño(item);
    item.fechaOrdenInicioEnMesAño = fechaOrdenInicioEnMesAño;
    const mesUltimoPagoContratistaMesAño = formulas.getMesUltimoPagoContratistaMesAño(item);
    item.mesUltimoPagoContratistaMesAño = mesUltimoPagoContratistaMesAño;
    const montoContractualInicialDolaresTasaCambioMesYMoneda =
        formulas.getMontoContractualInicialDolaresTasaCambioMesYMoneda(item);
    item.montoContractualInicialDolaresTasaCambioMesYMoneda =
        montoContractualInicialDolaresTasaCambioMesYMoneda;
    const montoContractualVigenteModificadoDolaresConTasaCambioMesYMoneda =
        formulas.getMontoContractualVigenteModificadoDolaresConTasaCambioMesYMoneda(item);
    item.montoContractualVigenteModificadoDolaresConTasaCambioMesYMoneda =
        montoContractualVigenteModificadoDolaresConTasaCambioMesYMoneda;
    const ficConTazasCambioDiferenciadas = formulas.getFicConTazasCambioDiferenciadas(item);
    item.ficConTazasCambioDiferenciadas = ficConTazasCambioDiferenciadas;
    return item;
};
export default function CreateProgram(props: { isUpdated: boolean }) {
    const params: any = useParams<{}>();
    const programasService = ProgramasService({ locale: 'en' });
    const notificationsService = NotificationsService({ locale: 'en' });
    const paisesService = PaisesService({ locale: 'en' });
    const obrasService = ObrasService({ locale: 'en' });
    const tipoObrasService = TipoObrasService({ locale: 'en' });
    const jefeEquiposService = JefeEquiposService({ locale: 'en' });
    const monedasService = MonedasService({ locale: 'en' });
    const estadosEjecucionService = EstadosEjecucionService({ locale: 'en' });
    const [paises, setPaises] = useState<Pais[]>([]);
    const [programas, setProgramas] = useState<Programa[]>([]);
    const [tipoObras, setTipoObras] = useState<TipoObra[]>([]);
    const [jefeEquipos, setJefeEquipos] = useState<JefeEquipo[]>([]);
    const [monedas, setMonedas] = useState<Moneda[]>([]);
    const [estadosEjecucion, setEstadosEjecucion] = useState<EstadoEjecucion[]>([]);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [isUpdated, serIsUpdated] = React.useState<boolean>(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [columns, setColumns] = React.useState<any[]>();
    const [columnsGrid, setColumnsGrid] = React.useState<any[]>();
    const [currentProgram, setCurrentProgram] = React.useState<number>(0);
    const currentDate = new Date();
    const [currentYear, setCurrentYear] = React.useState<number>(currentDate.getFullYear());
    const [currentMonth, setCurrentMonth] = React.useState<number>(currentDate.getMonth() + 1);
    const [isEdit, setIsEdit] = React.useState<boolean>(false);
    const [successSaved, setSuccessSaved] = useState<boolean>(false);
    const [invalidFields, setInvalidFields] = useState<boolean>(false);
    const [obras, setObras] = React.useState<ObraApp[]>([]);
    const [newObrasForUpdate, setNewObrasForUpdate] = React.useState<ObraApp[]>([]);
    const [emptyData, setEmptyData] = React.useState(false);
    const chooserList = ['SI', 'NO'];
    const intervaloManoCampo = ['> 250', '0-9', '10-49', '50-249'];
    const userRol = JSON.parse(localStorage.getItem('Roles') as string);
    const defaultPrograma: Programa = {
        oid: 0,
        descripcion: '',
        codigo: 0,
        optimisticLockField: 0,
    };
    const [programSelected, setProgramSelected] = React.useState<any>({
        value: defaultPrograma,
    });
    const [activeGuardarObraButton, setActiveGuardarObraButton] = useState(false);
    const [activeCreateObraButton, setActiveCreateObraButton] = useState(false);
    const fetchServices = () => {
        return new Promise((resolve, reject) => {
            const pCountries = paisesService.getPaises();
            const pPrograms = programasService.getProgramas();
            const pTipoObras = tipoObrasService.getTipoObras();
            const pJefeEquipos = jefeEquiposService.getJefeEquipos();
            const pMonedas = monedasService.getMonedas();
            const pEstadosEjecucion = estadosEjecucionService.getEstadosEjecucion();
            Promise.all([
                pCountries,
                pPrograms,
                pTipoObras,
                pJefeEquipos,
                pMonedas,
                pEstadosEjecucion,
            ]).then((response) => {
                const paisesR = response[0].data;
                const programasR = response[1].data;
                const tipoObrasR = response[2].data;
                const jefeEquiposR = response[3].data;
                const estadosEjecucionR = response[5].data;
                const monedasR = response[4].data;

                setPaises(paisesR);

                setProgramas(programasR);
                setTipoObras(tipoObrasR);
                setJefeEquipos(jefeEquiposR);
                setMonedas(monedasR);
                setEstadosEjecucion(estadosEjecucionR);

                const p_programId = params['programId'];
                const p_year = params['year'];
                const p_month = params['month'];
                if (p_programId && p_year && p_month) {
                    const programId = Number(p_programId);
                    const year = Number(p_year);
                    const month = Number(p_month);
                    setIsEdit(true);
                    setCurrentProgram(programId);
                    const program = response[1].data.filter((s) => s.oid === programId)[0];
                    setProgramSelected({ value: program });
                    setActiveGuardarObraButton(true);
                    setCurrentYear(year);
                    setCurrentMonth(month);
                    setTimeout(() => {
                        loadObras(
                            programId,
                            year,
                            month,
                            true,
                            paisesR,
                            programasR,
                            tipoObrasR,
                            jefeEquiposR,
                            monedasR,
                            estadosEjecucionR
                        );
                    });
                }

                resolve(true);
            });
        });
    };

    function isInvalid(value: any): string {
        let result = '';
        if (!value) {
            result = 'required-e';
        }
        return result;
    }

    const years = () => {
        let result = [];
        for (let i = new Date().getFullYear() - 1; i < new Date().getFullYear() + 10; i++) {
            result.push(i);
        }
        return result;
    };

    const months = () => {
        let result = [];
        for (let i = 0; i < 12; i++) {
            result.push(i + 1);
        }
        return result;
    };

    const loadObras = (
        programP: number,
        yearP: number,
        monthP: number,
        isEditP = false,
        paisesP: Pais[],
        programasP: Programa[],
        tipoObrasP: TipoObra[],
        jefeEquiposP: JefeEquipo[],
        monedasP: Moneda[],
        estadosEjecucionP: EstadoEjecucion[],
        reSearch = 1
    ) => {
        setLoading(true);
        if (programP && yearP && monthP) {
            const filter: ObraFilter = {
                year: yearP,
                month: monthP,
                programa: programP,
            };
            let { year, month } = filter;

            obrasService.getObrasApp(filter).then((response: any) => {
                if (response.data.length <= 0 && reSearch > 0) {
                    if (month === 1) {
                        year!--;
                        month! = 12;
                    } else {
                        month!--;
                    }
                    loadObras(
                        programP,
                        year!,
                        month!,
                        isEditP,
                        paisesP,
                        programasP,
                        tipoObrasP,
                        jefeEquiposP,
                        monedasP,
                        estadosEjecucionP,
                        0
                    );
                } else {
                    let result: ObraApp[] = [];
                    let data = response.data;

                    data.map((obra: ObraApp) => {
                        obra.fecha = formateDate(new Date(obra.fecha));
                        obra.fechaInicio = formateDate(new Date(obra.fechaInicio!));
                        obra.fechaFinalizacionVigente = formateDate(
                            new Date(obra.fechaFinalizacionVigente!)
                        );
                        obra.fechaFinalizacionEstimada = formateDate(
                            new Date(obra.fechaFinalizacionEstimada!)
                        );
                        obra.mesUltPagoContratista = obra.mesUltPagoContratista
                            ? formateDate(new Date(obra.mesUltPagoContratista))
                            : obra.mesUltPagoContratista;
                        return obra;
                    });
                    for (let i = 0; i < data.length; i++) {
                        let obra: ObraApp = {
                            index: i,
                            oid: data[i].oid,
                            actaSuspencionFirmada: data[i].actaSuspencionFirmada,
                            actaSuspencionMesFirma: data[i].actaSuspencionMesFirma
                                ? new Date(data[i].actaSuspencionMesFirma)
                                : null,
                            anoFinalizaciónContrato: data[i].anoFinalizaciónContrato,
                            apareceEnBaseDeDatos: data[i].apareceEnBaseDeDatos,
                            avanceDePlazoPlazoIntermedio: data[i].avanceDePlazoPlazoIntermedio,
                            cantidadManoObra: data[i].cantidadManoObra,
                            cantidadObreroCesados: data[i].cantidadObreroCesados,
                            clasificacionDeSobrecostos: data[i].clasificacionDeSobrecostos,
                            clasificacionPorKm: data[i].clasificacionPorKm,
                            clasificacionPorMontos: data[i].clasificacionPorMontos,
                            clasificacionPorPlazo: data[i].clasificacionPorPlazo,
                            clasificacionPorSobreplazo: data[i].clasificacionPorSobreplazo,
                            contratista1: data[i].contratista1,
                            contratista2: data[i].contratista2,
                            contratistaConsorciosObra: data[i].contratistaConsorciosObra,
                            desapareceDeBaseDeDatos: data[i].desapareceDeBaseDeDatos,
                            empresaSupervisora: data[i].empresaSupervisora,
                            estadoDeAvanceGeneral: data[i].estadoDeAvanceGeneral,
                            estadoEjecucion: data[i].estadoEjecucion,
                            estadoEjecucionItem: estadosEjecucionP.filter(
                                (s) => s.oid === data[i].estadoEjecucion
                            )[0],
                            externalIdCaptudata1: data[i].externalIdCaptudata1,
                            externalIdcaptudata: data[i].externalIdcaptudata,
                            f103: data[i].f103,
                            fecha: data[i].fecha,
                            fechaActualizacion: new Date(),
                            fechaDeOrdenDeInicioEnMesAño: data[i].fechaDeOrdenDeInicioEnMesAño,
                            fechaFinalizacionEstimada: data[i].fechaFinalizacionEstimada
                                ? new Date(data[i].fechaFinalizacionEstimada)
                                : null,
                            fechaFinalizacionVigente: data[i].fechaFinalizacionVigente
                                ? new Date(data[i].fechaFinalizacionVigente)
                                : null,
                            fechaInicio: data[i].fechaInicio ? new Date(data[i].fechaInicio) : null,
                            fechaRecibioInformación: data[i].fechaRecibioInformación
                                ? new Date(data[i].fechaRecibioInformación)
                                : null,
                            ficConTazasCambioDiferenciadas: data[i].ficConTazasCambioDiferenciadas,
                            ficmetodologicoContratosActivos:
                                data[i].ficmetodologicoContratosActivos,
                            ficmetodologicoContratosActivosSinCeros:
                                data[i].ficmetodologicoContratosActivosSinCeros,
                            flexibilizacionClausulasContractuales:
                                data[i].flexibilizacionClausulasContractuales,
                            fpcmetodologicoContratosActivos:
                                data[i].fpcmetodologicoContratosActivos,
                            fpcmetodologicoContratosActivosSinCeros:
                                data[i].fpcmetodologicoContratosActivosSinCeros,
                            gcrecord: data[i].gcrecord,
                            jefeEquipo: data[i].jefeEquipo,
                            jefeEquipoItem: jefeEquiposP.filter(
                                (s) => s.oid === data[i].jefeEquipo
                            )[0],
                            latitud: data[i].latitud,
                            limitacionActividadesAdministrativas:
                                data[i].limitacionActividadesAdministrativas,
                            localizacion: data[i].localizacion,
                            longitud: data[i].longitud,
                            longitudKm: data[i].longitudKm,
                            manoObraPorMontoDeInversionMillones:
                                data[i].manoObraPorMontoDeInversionMillones,
                            mesDelÚltimoPagoAlContratistaEnMesAño:
                                data[i].mesDelÚltimoPagoAlContratistaEnMesAño,
                            mesUltPagoContratista: data[i].mesUltPagoContratista
                                ? new Date(data[i].mesUltPagoContratista)
                                : null,
                            moneda: data[i].moneda,
                            monedaItem: monedasP.filter((s) => s.oid === data[i].moneda)[0],
                            montoContractualDolares: data[i].montoContractualDolares,
                            montoContractualDolaresEnMillones:
                                data[i].montoContractualDolaresEnMillones,
                            montoContractualInicialEnDólaresConTasaDeCambioPorMes:
                                data[i].montoContractualInicialEnDólaresConTasaDeCambioPorMes,
                            montoContractualVigenteModificadoDolares:
                                data[i].montoContractualVigenteModificadoDolares,
                            montoContractualVigenteModificadoDolaresEnMillones:
                                data[i].montoContractualVigenteModificadoDolaresEnMillones,
                            montoContractualVigenteModificadoDólaresConTasaDeCam:
                                data[i].montoContractualVigenteModificadoDólaresConTasaDeCam,
                            montoInicial: data[i].montoInicial,
                            montoVigente: data[i].montoVigente,
                            muestraDeChequeo: data[i].muestraDeChequeo,
                            nacionalidadContratista: data[i].nacionalidadContratista,
                            nacionalidadEmpresaSupervisora: data[i].nacionalidadEmpresaSupervisora,
                            nombre: data[i].nombre,
                            nota: data[i].nota,
                            notaFinalEstadoGeneral: data[i].notaFinalEstadoGeneral,
                            notaFinalSobrecostos: data[i].notaFinalSobrecostos,
                            notaFinalSobreplazo: data[i].notaFinalSobreplazo,
                            nuevoCronograma: data[i].nuevoCronograma,
                            optimisticLockField: data[i].optimisticLockField,
                            orden: data[i].orden,
                            pagado: data[i].pagado,
                            pagoStockMateriales: data[i].pagoStockMateriales,
                            pais: data[i].pais,
                            paisItem: paisesP.filter((s) => s.oid === data[i].pais)[0],
                            pendientePorVerificar: data[i].pendientePorVerificar,
                            plazoContractualVigente: data[i].plazoContractualVigente,
                            plazoContractualVigentePasoIntermedio:
                                data[i].plazoContractualVigentePasoIntermedio,
                            plazoInicialMeses: data[i].plazoInicialMeses,
                            plazoInicialPorKm: data[i].plazoInicialPorKm,
                            plazoVigentePorKm: data[i].plazoVigentePorKm,
                            ponderadorFicMca: data[i].ponderadorFicMca,
                            ponderadorFicMcasinCeros: data[i].ponderadorFicMcasinCeros,
                            ponderadorPfc: data[i].ponderadorPfc,
                            ponderadorPfcMcasinCeros: data[i].ponderadorPfcMcasinCeros,
                            porcentajeAvanceAcumulado: data[i].porcentajeAvanceAcumulado,
                            porcentajeAvanceDePlazo: data[i].porcentajeAvanceDePlazo,
                            porcentajeBid: data[i].porcentajeBid,
                            porcentajeContrapartida: data[i].porcentajeContrapartida,
                            precioInicialPorKmMillones: data[i].precioInicialPorKmMillones,
                            precioVigentePorKmMillones: data[i].precioVigentePorKmMillones,
                            problemaCadenaSuministros: data[i].problemaCadenaSuministros,
                            programa: data[i].programa,
                            programItem: programasP.filter((s) => s.oid === data[i].programa)[0],
                            provincia: data[i].provincia,
                            seSuscribioAdenda: data[i].seSuscribioAdenda,
                            sobreCostoEstimado: data[i].sobreCostoEstimado,
                            sobreCostoEstimadoNoMaterializado:
                                data[i].sobreCostoEstimadoNoMaterializado,
                            sobrecostosMaterializados: data[i].sobrecostosMaterializados,
                            sobrecostosUsd: data[i].sobrecostosUsd,
                            sobrecostosUsdenMillones: data[i].sobrecostosUsdenMillones,
                            sobreplazoMesesCalculado: data[i].sobreplazoMesesCalculado,
                            subRegion: data[i].subRegion,
                            supervisora1: data[i].supervisora1,
                            tipoCambio: data[i].tipoCambio,
                            tipoCambioPorMesYmoneda: data[i].tipoCambioPorMesYmoneda,
                            tipoDeCambioPorMesYMonedaSegúnFechaDeInicioDeObras:
                                data[i].tipoDeCambioPorMesYMonedaSegúnFechaDeInicioDeObras,
                            tipoDeCambioPorMesYMonedaSegúnMesDePagoAContratista:
                                data[i].tipoDeCambioPorMesYMonedaSegúnMesDePagoAContratista,
                            tipoObra: data[i].tipoObra,
                            tipoObraItem: tipoObrasP.filter((s) => s.oid === data[i].tipoObra)[0],
                            totalPagoHastaLaFechaDolares: data[i].totalPagoHastaLaFechaDolares,
                            tramo: data[i].tramo,
                            _: data[i]._,
                            _2020: data[i]._2020,
                            _2021: data[i]._2021,
                            _2022: data[i]._2022,
                            _2023: data[i]._2023,
                            _2024: data[i]._2024,
                            _2025: data[i]._2025,
                            rowClass:
                                data[i].estadoEjecucion &&
                                estadosEjecucionP.filter(
                                    (s) => s.oid === data[i].estadoEjecucion
                                )[0].nombre === 'Finalizada'
                                    ? 'rowProjectClosed'
                                    : null,
                            locked:
                                data[i].estadoEjecucion &&
                                estadosEjecucionP.filter(
                                    (s) => s.oid === data[i].estadoEjecucion
                                )[0].nombre === 'Finalizada',

                            // validators
                            invalidCountry: false,
                            invalidName: false,
                            invalidLocalCoin: false,
                            invalidInitialAmount: false,
                            invalidFinalDate: false,
                            invalidCurrentAmount: false,
                            invalidPayed: false,
                            invalidExecutionState: false,
                            invalidTeamLeader: false,
                        };
                        if (obra.fecha !== null) {
                            obra.fecha = new Date(obra.fecha);
                        }
                        const programFilter = programasP.filter((s) => s.oid === obra.programa);
                        if (programFilter.length > 0) obra.programItem = programFilter[0];

                        const countryFilter = paisesP.filter((s) => s.oid === obra.pais);
                        if (countryFilter.length > 0) obra.paisItem = countryFilter[0];
                        result.push(obra);
                    }
                    if (reSearch === 0 && response.data.length > 0) {
                        const result2: ObraApp[] = result.filter(
                            (obra) => obra.estadoEjecucion !== 7
                        );
                        setEmptyData(true);
                        setNewObrasForUpdate(result2);
                        setObras(result2);
                        setActiveCreateObraButton(true);
                    } else {
                        if (reSearch === 0 && response.data.length <= 0) {
                            setActiveCreateObraButton(false);
                        } else {
                            setActiveCreateObraButton(true);
                        }
                        setEmptyData(false);
                        setNewObrasForUpdate(result);
                        setObras(result);
                    }
                    loadGridColumns(
                        paisesP,
                        programasP,
                        tipoObrasP,
                        jefeEquiposP,
                        monedasP,
                        estadosEjecucionP,
                        result,
                        isEditP
                    );
                    setLoading(false);
                }
            });
        } else {
            setLoading(false);
        }
    };

    const changeFields = (item: ObraApp) => {
        item.montoContractualDolares = formulas.getMontoContractualDolares(item);
        item.montoContractualDolaresEnMillones =
            formulas.getMontoContractualEnDolaresMillones(item);
    };

    const requiredOnwer = (): boolean => {
        let result = false;
        if (localStorage.getItem('Roles')) {
            const owner = userRol ? userRol.filter((s: any) => s.Name === 'Owner') : null;
            if (owner && owner.length > 0) {
                result = true;
            }
        }
        return result;
    };

    const getHeader = (column: string) => {
        const title = column;
        return (
            <div>
                <HtmlTooltip title={title} placement='top-start' arrow>
                    <div>
                        <span className='fecha-grid'></span>
                        <HtmlTooltip
                            title='Ingresa el tipo de cambio de la moneda'
                            placement='right-end'
                            arrow>
                            <div className='tooltip-grid-money tooltip-grid'>
                                <span className='tooltip-Tooltip_de_moneda'></span>
                            </div>
                        </HtmlTooltip>

                        {title}
                    </div>
                </HtmlTooltip>
            </div>
        );
    };

    const getTooltipHeader = (header: string) => {
        return (
            <HtmlTooltip title={header} placement='top-start' arrow>
                <div>{header}</div>
            </HtmlTooltip>
        );
    };

    const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
        <Tooltip {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            color: '#000000',
            maxWidth: 5000,
            fontSize: theme.typography.pxToRem(12),
        },
    }));

    useEffect(() => {
        requiredOnwer();
        setLoading(true);
        setTimeout(() => {
            fetchServices();
            setLoading(false);
        });
        if (props.isUpdated !== undefined) {
            serIsUpdated(props.isUpdated);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function TimestampFormatter({ timestamp }: { timestamp: number }) {
        return <>{timestamp ? moment(timestamp).format('MM/DD/YYYY') : ''}</>;
    }

    function isNumber(value: any): boolean {
        let result = true;
        if (value && value.length > 0) {
            if (isNaN(Number(value))) {
                result = false;
            }
        } else {
            result = false;
        }
        return result;
    }

    function loadGridColumns(
        paisItems: Pais[],
        programItems: Programa[],
        tipoObras: TipoObra[],
        jefeEquipos: JefeEquipo[],
        monedas: Moneda[],
        estadosEjecucion: EstadoEjecucion[],
        obras: ObraApp[],
        isEditP: boolean
    ) {
        const tooltip = () => {
            return (
                <React.Fragment>
                    <HtmlTooltip
                        title='Si desea hacer cambios en esta celda contacte con un Administrador'
                        placement='right-end'
                        arrow>
                        <div className='tooltip-grid'>
                            <span className='tooltip-Icono_tooltip_informativo'></span>
                        </div>
                    </HtmlTooltip>
                </React.Fragment>
            );
        };
        const result: any[] = [
            {
                key: 'fecha',
                visible: true,
                name: getTooltipHeader('Fecha de Creación'),
                minWidth: 110,
                editable: false,
                resizable: true,
                formatter(props: any) {
                    return (
                        <React.Fragment>
                            {props.row.locked && (
                                <HtmlTooltip
                                    title='Este registro ya esta Finalizado, si desea hacer cambios contacte un Administrador'
                                    placement='right-end'
                                    arrow>
                                    <div className='tooltip-grid'>
                                        <span className='tooltip-Icono_tooltip_informativo'></span>
                                    </div>
                                </HtmlTooltip>
                            )}
                            {!props.row.locked && tooltip()}
                            <span className='fecha-grid'>
                                <TimestampFormatter timestamp={props.row.fecha} />
                            </span>
                        </React.Fragment>
                    );
                },
                editor(props: any) {
                    const {
                        avanceDePlazoPlazoIntermedio,
                        porcentajeAvanceDePlazo,
                        estadoDeAvanceGeneral,
                        notaFinalEstadoGeneral,
                    } = onChangeFuntions(props.row as ObraApp);
                    props.row.avanceDePlazoPlazoIntermedio = avanceDePlazoPlazoIntermedio;
                    props.row.porcentajeAvanceDePlazo = porcentajeAvanceDePlazo;
                    props.row.estadoDeAvanceGeneral = estadoDeAvanceGeneral;
                    props.row.notaFinalEstadoGeneral = notaFinalEstadoGeneral;
                },
                frozen: true,
            },
            {
                key: 'fechaActualizacion',
                visible: !isEditP ? true : false,
                name: getTooltipHeader('Fecha de Actualización'),
                minWidth: 110,
                editable: true,
                resizable: true,
                formatter(props: any) {
                    return (
                        <React.Fragment>
                            <span className='fecha-grid'>
                                <TimestampFormatter timestamp={props.row.fechaActualizacion} />
                            </span>
                        </React.Fragment>
                    );
                },
                frozen: true,
            },
            {
                key: 'programa',
                visible: false,
                name: getTooltipHeader('Programa'),
                minWidth: 110,
                editable: false,
                resizable: true,
                formatter(props: { row: ObraApp }) {
                    return (
                        <>
                            <span className='fecha-grid'></span>
                            {props.row.programItem?.descripcion}
                            {!props.row.locked && tooltip()}
                        </>
                    );
                },
                editor: (props: any) => (
                    <Select
                        menuPortalTarget={document.body}
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        key={`programa${props.row.oid}`}
                        isDisabled={true}
                        options={programItems.map((item: Programa) => {
                            return {
                                value: item.oid?.toString(),
                                label: item.descripcion,
                            };
                        })}
                        defaultValue={{
                            value: props.row.programItem.oid.toString(),
                            label: props.row.programItem.descripcion,
                        }}
                        onChange={(e: any) => {
                            if (e.value) {
                                props.row.programa = Number(e.value);
                                props.onRowChange(
                                    {
                                        ...props.row,
                                        jefeEquipo: Number(e.value),
                                        programaItem: programas.filter(
                                            (s) => s.oid === Number(e.value)
                                        )[0],
                                    },
                                    true
                                );
                            }
                            changeFields(props.row);
                        }}
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
                frozen: true,
            },
            {
                key: 'pais',
                visible: true,
                name: getTooltipHeader('País'),
                minWidth: 100,
                editable: false,
                resizable: true,
                formatter(props: any) {
                    return (
                        <>
                            <span className='fecha-grid'></span>
                            {props.row.paisItem.nombre}
                            {!props.row.locked && tooltip()}
                        </>
                    );
                },
                editor: (props: any) => (
                    <Select
                        menuPortalTarget={document.body}
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        key={`pais${props.row.oid}`}
                        autoFocus={true}
                        isDisabled={true}
                        onChange={(e: any) => {
                            if (e.value) {
                                props.row.pais = Number(e.value);
                                const { subRegion } = onChangeFuntions(props.row as ObraApp);
                                props.row.subRegion = subRegion;
                                props.onRowChange(
                                    {
                                        ...props.row,
                                        pais: Number(e.value),
                                        paisItem: paisItems.filter(
                                            (s) => s.oid === Number(e.value)
                                        )[0],
                                    },
                                    true
                                );
                            }
                            props.row.invalidCountry = false;
                        }}
                        placeholder={
                            props.row !== undefined && props.row.invalidName
                                ? 'Campo requerido'
                                : 'Ingrese el nombre de la obra'
                        }
                        options={paisItems.map((pais: Pais) => {
                            return { value: pais.oid, label: pais.nombre };
                        })}
                        defaultValue={{
                            value: props.row.paisItem.oid,
                            label: props.row.paisItem.nombre,
                        }}
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
                frozen: true,
            },
            {
                key: 'nombre',
                visible: true,
                name: getTooltipHeader('Nombre de la obra'),
                minWidth: 150,
                editable: false,
                resizable: true,
                formatter(props: any) {
                    return (
                        <>
                            <HtmlTooltip title={props.row.nombre} placement='top-start' arrow>
                                <span className='fecha-grid'>{props.row.nombre}</span>
                            </HtmlTooltip>
                            {!props.row.locked && tooltip()}
                        </>
                    );
                },
                editor: (props: any) => (
                    <input
                        autoFocus
                        type='text'
                        disabled={true}
                        defaultValue={props.row.nombre}
                        onChange={(e: any) => {
                            props.row.nombre = e.target.value;
                            props.onRowChange({
                                ...props.row,
                                nombre: props.row.nombre,
                            });
                            props.row.invalidName = false;
                        }}
                        placeholder={
                            props.row !== undefined && props.row.invalidName
                                ? 'Campo requerido'
                                : 'Ingrese el nombre de la obra'
                        }
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
                frozen: true,
            },
            {
                key: 'moneda',
                visible: true,
                name: getTooltipHeader('Moneda Local'),
                minWidth: 70,
                editable: false,
                resizable: true,
                formatter(props: any) {
                    return (
                        <>
                            <span className='fecha-grid'></span>
                            {props.row.monedaItem?.nombre}
                            {!props.row.locked && tooltip()}
                        </>
                    );
                },
                editor: (props: any) => (
                    <Select
                        menuPortalTarget={document.body}
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        isDisabled={true}
                        options={monedas.map((item: Moneda) => {
                            return {
                                value: item.oid?.toString(),
                                label: item.nombre,
                            };
                        })}
                        defaultValue={{
                            value: props.row.monedaItem.oid.toString(),
                            label: props.row.monedaItem.nombre,
                        }}
                        onChange={(e: any) => {
                            if (e.value) {
                                props.row.moneda = Number(e.value);
                                props.row.monedaItem = monedas.filter(
                                    (s) => s.oid === Number(e.value)
                                )[0];
                                props.onRowChange({
                                    ...props.row,
                                    moneda: props.row.moneda,
                                    monedaItem: props.row.monedaItem,
                                });
                            }
                            props.row.invalidLocalCoin = false;
                        }}
                        placeholder={
                            props.row !== undefined && props.row.invalidLocalCoin
                                ? 'Campo requerido'
                                : 'Ingrese el nombre de la obra'
                        }
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
                frozen: true,
            },
            {
                key: 'tipoCambio',
                visible: requiredOnwer() ? true : false,
                name: getHeader('Tipo cambio'),
                minWidth: 120,
                editable: true,
                resizable: true,
                formatter(props: any) {
                    if (props.row.tipoCambio === null) {
                        props.row.tipoCambio = 1;
                    }
                    const tipoCambio = props.row.tipoCambio;
                    return <>{tipoCambio ? Number(tipoCambio.toFixed(4)) : null}</>;
                },
                editor: (props: any) => (
                    <input
                        autoFocus
                        type='text'
                        defaultValue={props.row.tipoCambio}
                        onChange={(e: any) => {
                            if (!isNumber(e.target.value)) {
                                props.row.tipoCambio = null;
                            } else {
                                props.row.tipoCambio = Number(e.target.value);
                                const {
                                    totalPagoHastaLaFechaDolares,
                                    montoContractualInicialDolaresTasaCambioMesYMoneda,
                                    montoContractualVigenteModificadoDolaresConTasaCambioMesYMoneda,
                                } = onChangeFuntions(props.row as ObraApp);
                                props.row.totalPagoHastaLaFechaDolares =
                                    totalPagoHastaLaFechaDolares;
                                props.row.montoContractualInicialDolaresTasaCambioMesYMoneda =
                                    montoContractualInicialDolaresTasaCambioMesYMoneda;
                                props.row.montoContractualVigenteModificadoDolaresConTasaCambioMesYMoneda =
                                    montoContractualVigenteModificadoDolaresConTasaCambioMesYMoneda;
                                props.onRowChange({
                                    ...props.row,
                                    tipoCambio: props.row.tipoCambio,
                                });
                            }
                        }}
                        placeholder={
                            props.row !== undefined && props.row.invalidInitialAmount
                                ? 'Campo requerido'
                                : 'Ingrese el monto inicial'
                        }
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
                frozen: true,
            },
            {
                key: 'montoInicial',
                visible: true,
                name: getTooltipHeader('Monto Contractual Inicial'),
                minWidth: 150,
                editable: false,
                resizable: true,
                formatter(props: any) {
                    const montoInicial = props.row.montoInicial;
                    return (
                        <>
                            <span className='fecha-grid'></span>
                            {new Intl.NumberFormat().format(montoInicial)}
                            {!props.row.locked && tooltip()}
                        </>
                    );
                },
                editor: (props: any) => (
                    <input
                        autoFocus
                        type='text'
                        disabled={true}
                        defaultValue={props.row.montoInicial}
                        onChange={(e: any) => {
                            if (!isNumber(e.target.value)) {
                                props.row.montoInicial = null;
                            } else {
                                props.row.montoInicial = Number(e.target.value);
                                const {
                                    montoContractualInicialDolaresTasaCambioMesYMoneda,
                                    ficConTazasCambioDiferenciadas,
                                } = onChangeFuntions(props.row as ObraApp);
                                props.row.montoContractualInicialDolaresTasaCambioMesYMoneda =
                                    montoContractualInicialDolaresTasaCambioMesYMoneda;
                                props.row.ficConTazasCambioDiferenciadas =
                                    ficConTazasCambioDiferenciadas;
                                props.onRowChange({
                                    ...props.row,
                                    montoInicial: props.row.montoInicial,
                                });
                            }
                            props.row.invalidInitialAmount = false;
                        }}
                        placeholder={
                            props.row !== undefined && props.row.invalidInitialAmount
                                ? 'Campo requerido'
                                : 'Ingrese el monto inicial'
                        }
                    />
                ),

                editorOptions: {
                    editOnClick: true,
                },
            },
            {
                key: 'montoVigente',
                visible: true,
                name: getTooltipHeader('Monto Contractual Vigente'),
                minWidth: 150,
                editable: true,
                resizable: true,
                cellClass: (props: any) => isInvalid(props.montoVigente),
                formatter: (props: any) => new Intl.NumberFormat().format(props.row.montoVigente),
                editor: (props: any) => (
                    <input
                        autoFocus
                        type='text'
                        disabled={props.row.locked}
                        defaultValue={props.row.montoVigente}
                        onChange={(e: any) => {
                            if (!isNumber(e.target.value)) {
                                props.row.montoVigente = null;
                            } else {
                                props.row.montoVigente = Number(e.target.value);
                                const {
                                    montoContractualVigenteModificadoDolaresConTasaCambioMesYMoneda,
                                    ficConTazasCambioDiferenciadas,
                                } = onChangeFuntions(props.row as ObraApp);
                                props.row.montoContractualVigenteModificadoDolaresConTasaCambioMesYMoneda =
                                    montoContractualVigenteModificadoDolaresConTasaCambioMesYMoneda;
                                props.row.ficConTazasCambioDiferenciadas =
                                    ficConTazasCambioDiferenciadas;
                                props.onRowChange({
                                    ...props.row,
                                    montoVigente: props.row.montoVigente,
                                    invalidCurrentAmount: !props.row?.montoVigente,
                                });
                            }
                        }}
                        placeholder={
                            props.row !== undefined && props.row.invalidCurrentAmount
                                ? 'Campo requerido'
                                : 'Ingrese el monto vigente'
                        }
                    />
                ),

                editorOptions: {
                    editOnClick: true,
                },
            },
            {
                key: 'fechaInicio',
                visible: true,
                name: getTooltipHeader('Fecha de orden de inicio'),
                minWidth: 110,
                formatter(props: any) {
                    return (
                        <>
                            <span className='fecha-grid'></span>
                            {moment(props.row.fechaInicio).format('MM/D/YYYY')}
                            {!props.row.locked && tooltip()}
                        </>
                    );
                },
                editable: false,
                resizable: true,
                editor: (props: any) => (
                    <DatePicker
                        value={props.row.fechaInicio ? props.row.fechaInicio : null}
                        disabled={true}
                        onChange={(e: any) => {
                            if (e.target.value) {
                                props.row.fechaInicio = new Date(
                                    e.target.value.getFullYear(),
                                    e.target.value.getMonth(),
                                    e.target.value.getDate(),
                                    0,
                                    0,
                                    0
                                );
                                const {
                                    plazoContractualVigentePasoIntermedio,
                                    avanceDePlazoPlazoIntermedio,
                                    fechaDeOrdenDeInicioEnMesAño,
                                    mesUltimoPagoContratistaMesAño,
                                    plazoContractualVigente,
                                    clasificacionPorPlazo,
                                    porcentajeAvanceDePlazo,
                                    plazoVigentePorKm,
                                    sobreplazoMesesCalculado,
                                    estadoDeAvanceGeneral,
                                    notaFinalEstadoGeneral,
                                    clasificacionPorSobreplazo,
                                } = onChangeFuntions(props.row as ObraApp);
                                props.row.plazoContractualVigentePasoIntermedio =
                                    plazoContractualVigentePasoIntermedio;
                                props.row.avanceDePlazoPlazoIntermedio =
                                    avanceDePlazoPlazoIntermedio;
                                props.row.fechaDeOrdenDeInicioEnMesAño =
                                    fechaDeOrdenDeInicioEnMesAño;
                                props.row.mesUltimoPagoContratistaMesAño =
                                    mesUltimoPagoContratistaMesAño;
                                props.row.plazoContractualVigente = plazoContractualVigente;
                                props.row.clasificacionPorPlazo = clasificacionPorPlazo;
                                props.row.porcentajeAvanceDePlazo = porcentajeAvanceDePlazo;
                                props.row.plazoVigentePorKm = plazoVigentePorKm;
                                props.row.sobreplazoMesesCalculado = sobreplazoMesesCalculado;
                                props.row.estadoDeAvanceGeneral = estadoDeAvanceGeneral;
                                props.row.notaFinalEstadoGeneral = notaFinalEstadoGeneral;
                                props.row.clasificacionPorSobreplazo = clasificacionPorSobreplazo;
                                props.onRowChange({
                                    ...props.row,
                                    fechaInicio: props.row.fechaInicio
                                        ? props.row.fechaInicio
                                        : null,
                                });
                            } else {
                                props.onRowChange({
                                    ...props.row,
                                    fechaInicio: '',
                                });
                            }
                        }}
                        format='MM/dd/yyyy'
                        weekNumber={true}
                    />
                ),

                editorOptions: {
                    editOnClick: true,
                },
            },

            {
                key: 'mesUltPagoContratista',
                visible: true,
                name: getTooltipHeader('Mes último pago al contratista'),
                minWidth: 150,
                formatter(props: any) {
                    return (
                        <p>
                            {props.row.mesUltPagoContratista
                                ? moment(props.row.mesUltPagoContratista).format('MM/D/YYYY')
                                : null}
                        </p>
                    );
                },
                editable: true,
                resizable: true,
                cellClass: (props: any) => isInvalid(props.mesUltPagoContratista),
                editor: (props: any) => (
                    <DatePicker
                        value={
                            props.row.mesUltPagoContratista
                                ? new Date(props.row.mesUltPagoContratista)
                                : null
                        }
                        onChange={(e: any) => {
                            if (e.target.value) {
                                const newDatePick = new Date(
                                    e.target.value.getFullYear(),
                                    e.target.value.getMonth(),
                                    e.target.value.getDate(),
                                    0,
                                    0,
                                    0
                                );
                                props.onRowChange({
                                    ...props.row,
                                    mesUltPagoContratista: newDatePick ? newDatePick : null,
                                    invalidLastMonthContratist: !props.row?.mesUltPagoContratista,
                                });
                            } else {
                                props.onRowChange({
                                    ...props.row,
                                    mesUltPagoContratista: '',
                                });
                            }
                        }}
                        format='MM/dd/yyyy'
                        disabled={props.row.locked}
                        weekNumber={true}
                    />
                ),

                editorOptions: {
                    editOnClick: true,
                },
            },
            {
                key: 'pagado',
                visible: true,
                name: getTooltipHeader('Total pago hasta la fecha'),
                minWidth: 150,
                editable: true,
                resizable: true,
                cellClass: (props: any) => isInvalid(props.pagado),
                formatter: (props: any) => new Intl.NumberFormat().format(props.row.pagado),
                editor: (props: any) => (
                    <input
                        key={`pagado${props.row.oid}`}
                        disabled={props.row.locked}
                        autoFocus
                        type='text'
                        onChange={(e: any) => {
                            if (!isNumber(e.target.value)) {
                                props.row.pagado = null;
                            } else {
                                props.row.pagado = Number(e.target.value);
                                const {
                                    totalPagoHastaLaFechaDolares,
                                    porcentajeAvanceAcumulado,
                                    notaFinalEstadoGeneral,
                                } = onChangeFuntions(props.row as ObraApp);
                                props.row.totalPagoHastaLaFechaDolares =
                                    totalPagoHastaLaFechaDolares;
                                props.row.porcentajeAvanceAcumulado = porcentajeAvanceAcumulado;
                                props.row.notaFinalEstadoGeneral = notaFinalEstadoGeneral;
                                props.onRowChange({
                                    ...props.row,
                                    pagado: props.row.pagado,
                                    invalidPayed: !props.row?.pagado,
                                });
                            }
                        }}
                        placeholder={
                            props.row !== undefined && props.row.invalidPayed
                                ? 'Campo requerido'
                                : 'Ingrese el total pago hasta la fecha'
                        }
                        defaultValue={props.row.pagado}
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
            },
            {
                key: 'fechaFinalizacionVigente',
                visible: true,
                name: getTooltipHeader('Fecha de finalización vigente'),
                minWidth: 110,
                formatter(props: any) {
                    return <TimestampFormatter timestamp={props.row.fechaFinalizacionVigente} />;
                },
                cellClass: (props: any) => isInvalid(props.fechaFinalizacionVigente),
                editor: (props: any) => {
                    return (
                        <DatePicker
                            value={
                                props.row.fechaFinalizacionVigente
                                    ? new Date(props.row.fechaFinalizacionVigente)
                                    : null
                            }
                            onChange={(e: any) => {
                                if (e.target.value) {
                                    props.row.fechaFinalizacionVigente = new Date(
                                        e.target.value.getFullYear(),
                                        e.target.value.getMonth(),
                                        e.target.value.getDate(),
                                        0,
                                        0,
                                        0
                                    );
                                    const {
                                        plazoContractualVigentePasoIntermedio,
                                        anoFinalizaciónContrato,
                                        plazoContractualVigente,
                                        clasificacionPorPlazo,
                                        porcentajeAvanceDePlazo,
                                        _2020,
                                        _2021,
                                        _2022,
                                        _2023,
                                        _2024,
                                        _2025,
                                        sobreplazoMesesCalculado,
                                        plazoVigentePorKm,
                                        notaFinalEstadoGeneral,
                                        clasificacionPorSobreplazo,
                                    } = onChangeFuntions(props.row as ObraApp);
                                    props.row.plazoContractualVigentePasoIntermedio =
                                        plazoContractualVigentePasoIntermedio;
                                    props.row.anoFinalizaciónContrato = anoFinalizaciónContrato;
                                    props.row.plazoContractualVigente = plazoContractualVigente;
                                    props.row.clasificacionPorPlazo = clasificacionPorPlazo;
                                    props.row.porcentajeAvanceDePlazo = porcentajeAvanceDePlazo;
                                    props.row._2020 = _2020;
                                    props.row._2021 = _2021;
                                    props.row._2022 = _2022;
                                    props.row._2023 = _2023;
                                    props.row._2024 = _2024;
                                    props.row._2025 = _2025;
                                    props.row.sobreplazoMesesCalculado = sobreplazoMesesCalculado;
                                    props.row.plazoVigentePorKm = plazoVigentePorKm;
                                    props.row.notaFinalEstadoGeneral = notaFinalEstadoGeneral;
                                    props.row.clasificacionPorSobreplazo =
                                        clasificacionPorSobreplazo;
                                    props.onRowChange({
                                        ...props.row,
                                        fechaFinalizacionVigente: props.row.fechaFinalizacionVigente
                                            ? props.row.fechaFinalizacionVigente
                                            : null,
                                        invalidFinalDate: !props.row?.fechaFinalizacionVigente,
                                    });
                                } else {
                                    props.onRowChange({
                                        ...props.row,
                                        fechaFinalizacionVigente: '',
                                    });
                                }
                            }}
                            format='MM/dd/yyyy'
                            disabled={props.row.locked}
                            weekNumber={true}
                        />
                    );
                },

                editorOptions: {
                    editOnClick: true,
                },
                editable: true,
                resizable: true,
            },
            {
                key: 'fechaFinalizacionEstimada',
                visible: true,
                name: getTooltipHeader(
                    'Fecha de finalización estimada (en caso de preveerse aumento de plazo aún no formalizado)'
                ),
                minWidth: 180,
                editable: true,
                resizable: true,
                formatter(props: any) {
                    return <TimestampFormatter timestamp={props.row.fechaFinalizacionEstimada} />;
                },
                editor: (props: any) => (
                    <DatePicker
                        value={
                            props.row.fechaFinalizacionEstimada
                                ? new Date(props.row.fechaFinalizacionEstimada)
                                : null
                        }
                        disabled={props.row.locked}
                        onChange={(e: any) => {
                            if (e.target.value) {
                                const newDatePick = new Date(
                                    e.target.value.getFullYear(),
                                    e.target.value.getMonth(),
                                    e.target.value.getDate(),
                                    0,
                                    0,
                                    0
                                );
                                props.onRowChange({
                                    ...props.row,
                                    fechaFinalizacionEstimada: newDatePick ? newDatePick : null,
                                });
                            } else {
                                props.onRowChange({
                                    ...props.row,
                                    fechaFinalizacionEstimada: '',
                                });
                            }
                        }}
                        format='MM/dd/yyyy'
                        weekNumber={true}
                    />
                ),

                editorOptions: {
                    editOnClick: true,
                },
            },
            {
                key: 'cantidadManoObra',
                visible: true,
                name: getTooltipHeader('Cantidad mano de obra directa en campo'),
                minWidth: 75,
                editable: true,
                resizable: true,
                editor: (props: any) => (
                    <Select
                        menuPortalTarget={document.body}
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        key={`cantidadManoObra${props.row.oid}`}
                        autoFocus={true}
                        isDisabled={props.row.locked}
                        options={intervaloManoCampo.map((choose: string) => {
                            return { value: choose, label: choose };
                        })}
                        defaultValue={{
                            value: props.row?.cantidadManoObra,
                            label: props.row?.cantidadManoObra,
                        }}
                        onChange={(e: any) => {
                            props.row.cantidadManoObra = e.value;
                            if (e.value) {
                                props.onRowChange({
                                    ...props.row,
                                    cantidadManoObra: e.value,
                                });
                            }
                        }}
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
            },
            {
                key: 'estadoEjecucion',
                visible: true,
                name: getTooltipHeader('Estado de Ejecución'),
                minWidth: 150,
                editable: true,
                resizable: true,
                formatter(props: any) {
                    return <>{props.row.estadoEjecucionItem?.nombre}</>;
                },
                cellClass: (props: any) => isInvalid(props.estadoEjecucion),
                editor: (props: any) => (
                    <Select
                        menuPortalTarget={document.body}
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        key={`estadoEjecucion${props.row.oid}`}
                        autoFocus={true}
                        isDisabled={props.row.locked}
                        onChange={(e: any) => {
                            if (e.value) {
                                props.row.estadoEjecucion = Number(e.value);
                                const {
                                    estadoDeAvanceGeneral,
                                    ficmetodologicoContratosActivos,
                                    fpcmetodologicoContratosActivos,
                                    ficmetodologicoContratosActivosSinCeros,
                                    ponderadorFicMca,
                                    ponderadorPfc,
                                    fpcmetodologicoContratosActivosSinCeros,
                                    ponderadorFicMcasinCeros,
                                    ponderadorPfcMcasinCeros,
                                } = onChangeFuntions(props.row as ObraApp);
                                props.row.estadoDeAvanceGeneral = estadoDeAvanceGeneral;
                                props.row.ficmetodologicoContratosActivos =
                                    ficmetodologicoContratosActivos;
                                props.row.fpcmetodologicoContratosActivos =
                                    fpcmetodologicoContratosActivos;
                                props.row.ficmetodologicoContratosActivosSinCeros =
                                    ficmetodologicoContratosActivosSinCeros;
                                props.row.ponderadorFicMca = ponderadorFicMca;
                                props.row.ponderadorPfc = ponderadorPfc;
                                props.row.fpcmetodologicoContratosActivosSinCeros =
                                    fpcmetodologicoContratosActivosSinCeros;
                                props.row.ponderadorFicMcasinCeros = ponderadorFicMcasinCeros;
                                props.row.ponderadorPfcMcasinCeros = ponderadorPfcMcasinCeros;
                                props.row.estadoEjecucionItem = estadosEjecucion.filter(
                                    (s) => s.oid === Number(e.value)
                                )[0];
                                props.onRowChange(
                                    {
                                        ...props.row,
                                        estadoEjecucion: Number(e.value),
                                        estadoEjecucionItem: props.row.estadoEjecucionItem,
                                        invalidExecutionState: !props.row?.estadoEjecucionItem,
                                    },
                                    true
                                );
                            }
                        }}
                        placeholder={
                            props.row !== undefined && props.row.invalidExecutionState
                                ? 'Campo requerido'
                                : 'Ingrese el estado de ejecución'
                        }
                        options={estadosEjecucion.map((estado: EstadoEjecucion) => {
                            return {
                                value: estado.oid && estado.oid.toString(),
                                label: estado.nombre,
                            };
                        })}
                        defaultValue={{
                            value: props.row.estadoEjecucionItem.oid.toString(),
                            label: props.row.estadoEjecucionItem.nombre,
                        }}
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
            },
            {
                key: 'plazoInicialMeses',
                visible: true,
                name: getTooltipHeader('Plazo contractual inicial (meses)'),
                minWidth: 50,
                editable: true,
                resizable: true,
                editor: (props: any) => (
                    <input
                        key={`plazoInicialMeses${props.row.oid}`}
                        disabled={props.row.locked}
                        autoFocus
                        type='text'
                        onChange={(e: any) => {
                            if (!isNumber(e.target.value)) {
                                props.row.plazoInicialMeses = null;
                            } else {
                                props.row.plazoInicialMeses = Number(e.target.value);
                                const {
                                    plazoInicialMeses,
                                    plazoInicialPorKm,
                                    plazoContractualVigente,
                                    sobreplazoMesesCalculado,
                                    ponderadorPfc,
                                    ponderadorPfcMcasinCeros,
                                    plazoVigentePorKm,
                                    clasificacionPorSobreplazo,
                                } = onChangeFuntions(props.row as ObraApp);
                                props.row.plazoInicialMeses = plazoInicialMeses;
                                props.row.plazoInicialPorKm = plazoInicialPorKm;
                                props.row.plazoContractualVigente = plazoContractualVigente;
                                props.row.sobreplazoMesesCalculado = sobreplazoMesesCalculado;
                                props.row.ponderadorPfcMcasinCeros = ponderadorPfcMcasinCeros;
                                props.row.ponderadorPfc = ponderadorPfc;
                                props.row.plazoVigentePorKm = plazoVigentePorKm;
                                props.row.clasificacionPorSobreplazo = clasificacionPorSobreplazo;
                                props.onRowChange({
                                    ...props.row,
                                    plazoInicialMeses: props.row.plazoInicialMeses,
                                });
                            }
                        }}
                        defaultValue={props.row.plazoInicialMeses}
                    />
                ),
            },
            {
                key: 'sobreCostoEstimado',
                visible: true,
                name: getTooltipHeader('Sobrecostos estimados'),
                minWidth: 160,
                editable: true,
                resizable: true,
                formatter: (props: any) =>
                    new Intl.NumberFormat().format(props.row.sobreCostoEstimado),
                editor: (props: any) => (
                    <input
                        autoFocus
                        type='text'
                        disabled={props.row.locked}
                        defaultValue={props.row.sobreCostoEstimado}
                        onChange={(e: any) => {
                            if (e && !isNumber(e.target.value)) {
                                props.row.sobreCostoEstimado = null;
                            } else {
                                props.row.sobreCostoEstimado = Number(e.target.value);
                                props.onRowChange({
                                    ...props.row,
                                    sobreCostoEstimado: props.row.sobreCostoEstimado,
                                });
                            }
                        }}
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
            },
            {
                key: 'seSuscribioAdenda',
                visible: true,
                name: getTooltipHeader('¿Se suscribio adenda del contrato de obra?'),
                minWidth: 80,
                editable: true,
                resizable: true,
                editor: (props: any) => (
                    <Select
                        menuPortalTarget={document.body}
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        key={`seSuscribioAdenda${props.row.oid}`}
                        autoFocus={true}
                        isDisabled={props.row.locked}
                        options={chooserList.map((choose: string) => {
                            return { value: choose, label: choose };
                        })}
                        defaultValue={{
                            value: props.row?.seSuscribioAdenda,
                            label: props.row?.seSuscribioAdenda,
                        }}
                        onChange={(e: any) => {
                            props.row.seSuscribioAdenda = e.value;
                            if (e.value) {
                                props.onRowChange({
                                    ...props.row,
                                    seSuscribioAdenda: e.value,
                                });
                            }
                        }}
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
            },
            {
                key: 'jefeEquipo',
                visible: true,
                name: getTooltipHeader('Jefe de Equipo'),
                minWidth: 150,
                editable: true,
                resizable: true,
                formatter(props: any) {
                    return <>{props.row.jefeEquipoItem.nombre}</>;
                },
                cellClass: (props: any) => isInvalid(props.estadoEjecucion),

                editor: (props: any) => (
                    <Select
                        menuPortalTarget={document.body}
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        key={`jefeEquipo${props.row.oid}`}
                        autoFocus={true}
                        isDisabled={props.row.locked}
                        options={jefeEquipos.map((jefe: JefeEquipo) => {
                            return {
                                value: jefe.oid?.toString(),
                                label: jefe.nombre,
                            };
                        })}
                        defaultValue={{
                            value: props.row.jefeEquipoItem.oid.toString(),
                            label: props.row.jefeEquipoItem.nombre,
                        }}
                        onChange={(e: any) => {
                            if (e.value) {
                                props.row.jefeEquipo = Number(e.value);
                                props.row.invalidTeamLeader = false;
                                props.onRowChange(
                                    {
                                        ...props.row,
                                        jefeEquipo: Number(e.value),
                                        jefeEquipoItem: jefeEquipos.filter(
                                            (s) => s.oid === Number(e.value)
                                        )[0],
                                        invalidTeamLeader: !props.row?.jefeEquipo,
                                    },
                                    true
                                );
                            }
                        }}
                        placeholder={
                            props.row !== undefined && props.row.invalidTeamLeader
                                ? 'Campo requerido'
                                : 'Ingrese el jefe de equipo'
                        }
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
            },
            {
                key: 'tramo',
                visible: true,
                name: getTooltipHeader('Tramo de la obra'),
                minWidth: 250,
                editable: false,
                resizable: true,
                formatter(props: any) {
                    return (
                        <>
                            <span className='fecha-grid'></span>
                            {props.row.tramo}
                            {!props.row.locked && tooltip()}
                        </>
                    );
                },
                editor: (props: any) => (
                    <input
                        autoFocus
                        type='text'
                        disabled={true}
                        defaultValue={props.row.tramo}
                        onChange={(e: any) => {
                            props.row.tramo = e.target.value;
                            props.onRowChange({
                                ...props.row,
                                tramo: props.row.tramo,
                            });
                        }}
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
            },
            {
                key: 'tipoObra',
                visible: true,
                name: getTooltipHeader('Tipo de Obra'),
                minWidth: 250,
                editable: false,
                resizable: true,
                formatter(props: any) {
                    return (
                        <>
                            <span className='fecha-grid'></span>
                            {props.row.tipoObraItem.descripcion}
                            {!props.row.locked && tooltip()}
                        </>
                    );
                },
                editor: (props: any) => (
                    <Select
                        menuPortalTarget={document.body}
                        styles={{
                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        }}
                        key={`tipoObra${props.row.oid}`}
                        isDisabled={true}
                        options={tipoObras.map((item: TipoObra) => {
                            return {
                                value: item.oid?.toString(),
                                label: item.descripcion,
                            };
                        })}
                        defaultValue={{
                            value: props.row.tipoObraItem?.oid?.toString(),
                            label: props.row.tipoObraItem?.descripcion,
                        }}
                        onChange={(e: any) => {
                            if (e.value) {
                                props.row.tipoObra = Number(e.value);
                                props.row.tipoObraItem = tipoObras.filter(
                                    (s) => s.oid === Number(e.value)
                                )[0];
                                props.onRowChange(
                                    {
                                        ...props.row,
                                        tipoObra: Number(e.value),
                                        tipoObraItem: props.row.tipoObraItem,
                                    },
                                    true
                                );
                            }
                        }}
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
            },
            {
                key: 'provincia',
                visible: true,
                name: getTooltipHeader('Departamento/Provincia'),
                minWidth: 180,
                editable: false,
                resizable: true,
                formatter(props: any) {
                    return (
                        <>
                            <span className='fecha-grid'></span>
                            {props.row.provincia}
                            {!props.row.locked && tooltip()}
                        </>
                    );
                },
                editor: (props: any) => (
                    <input
                        key={`provincia${props.row.oid}`}
                        disabled={true}
                        autoFocus
                        type='text'
                        onChange={(e: any) => {
                            if (e.target.value) {
                                props.row.provincia = e.target.value;
                                props.onRowChange({
                                    ...props.row,
                                    provincia: e.target.value,
                                });
                            }
                        }}
                        defaultValue={props.row.provincia}
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
            },
            {
                key: 'longitudKm',
                visible: true,
                name: getTooltipHeader('Longitud total del contrato (km)'),
                minWidth: 100,
                editable: false,
                resizable: true,
                formatter(props: any) {
                    return (
                        <>
                            <span className='fecha-grid'></span>
                            {props.row.longitudKm}
                            {!props.row.locked && tooltip()}
                        </>
                    );
                },
                editor: (props: any) => (
                    <input
                        key={`longitudKm${props.row.oid}`}
                        disabled={true}
                        autoFocus
                        type='number'
                        onChange={(e: any) => {
                            if (e.target.value) {
                                props.row.longitudKm = e.target.valueAsNumber;
                                const {
                                    clasificacionPorKm,
                                    precioInicialPorKmMillones,
                                    precioVigentePorKmMillones,
                                    plazoInicialPorKm,
                                    plazoVigentePorKm,
                                } = onChangeFuntions(props.row as ObraApp);
                                props.row.clasificacionPorKm = clasificacionPorKm;
                                props.row.precioInicialPorKmMillones = precioInicialPorKmMillones;
                                props.row.precioVigentePorKmMillones = precioVigentePorKmMillones;
                                props.row.plazoInicialPorKm = plazoInicialPorKm;
                                props.row.plazoVigentePorKm = plazoVigentePorKm;
                                props.onRowChange({
                                    ...props.row,
                                    longitudKm: e.target.valueAsNumber,
                                });
                            }
                        }}
                        defaultValue={props.row.longitudKm}
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
            },
            {
                key: 'porcentajeBid',
                visible: true,
                name: getTooltipHeader('% BID'),
                minWidth: 80,
                editable: false,
                resizable: true,
                formatter(props: any) {
                    const porcentajeBid = props.row.porcentajeBid;
                    let porcentajeBidFormatted = null;
                    if (porcentajeBid) {
                        porcentajeBidFormatted = Number(porcentajeBid.toFixed(2));
                    } else {
                        porcentajeBidFormatted = null;
                    }
                    return (
                        <>
                            <span className='fecha-grid'></span>
                            {porcentajeBidFormatted !== null
                                ? new Intl.NumberFormat('locales', {
                                      style: 'percent',
                                  }).format(porcentajeBidFormatted)
                                : null}
                            {!props.row.locked && tooltip()}
                        </>
                    );
                },
                editor: (props: any) => (
                    <input
                        key={`porcentajeBid${props.row.oid}`}
                        disabled={true}
                        autoFocus
                        type='number'
                        onChange={(e: any) => {
                            if (e.target.value) {
                                props.row.porcentajeBid = e.target.valueAsNumber;
                                props.onRowChange({
                                    ...props.row,
                                    porcentajeBid: e.target.valueAsNumber,
                                });
                            }
                        }}
                        defaultValue={props.row.porcentajeBid}
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
            },
            {
                key: 'porcentajeContrapartida',
                visible: true,
                name: getTooltipHeader('% Contrapartida'),
                minWidth: 80,
                editable: false,
                resizable: true,
                formatter(props: any) {
                    const porcentajeContrapartida = props.row.porcentajeContrapartida
                        ? props.row.porcentajeContrapartida
                        : 0;
                    const porcentajeContrapartidaFormatted = Number(
                        porcentajeContrapartida.toFixed(2)
                    );
                    props.row.porcentajeContrapartida = porcentajeContrapartida;
                    return (
                        <>
                            <span className='fecha-grid'></span>
                            {new Intl.NumberFormat('locales', {
                                style: 'percent',
                            }).format(porcentajeContrapartidaFormatted)}
                            {!props.row.locked && tooltip()}
                        </>
                    );
                },
                editor: (props: any) => (
                    <input
                        key={`porcentajeContrapartida${props.row.oid}`}
                        disabled={true}
                        autoFocus
                        type='number'
                        onChange={(e: any) => {
                            if (e.target.value) {
                                props.row.porcentajeContrapartida = e.target.valueAsNumber;
                                props.onRowChange({
                                    ...props.row,
                                    porcentajeContrapartida: e.target.valueAsNumber,
                                });
                            }
                        }}
                        defaultValue={props.row.porcentajeContrapartida}
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
            },
            {
                key: 'latitud',
                visible: true,
                name: getTooltipHeader('Latitud Coordenadas Geográficas'),
                minWidth: 100,
                editable: true,
                resizable: true,
                editor: (props: any) => (
                    <input
                        key={`latitud${props.row.oid}`}
                        disabled={props.row.locked}
                        autoFocus
                        type='text'
                        onChange={(e: any) => {
                            if (!isNumber(e.target.value)) {
                                props.row.latitud = null;
                            } else {
                                props.row.latitud = Number(e.target.value);
                                props.onRowChange({
                                    ...props.row,
                                    latitud: props.row.latitud,
                                });
                            }
                        }}
                        defaultValue={props.row.latitud}
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
            },
            {
                key: 'longitud',
                visible: true,
                name: getTooltipHeader('Longitud Coordenadas Geográficas'),
                minWidth: 100,
                editable: true,
                resizable: true,
                editor: (props: any) => (
                    <input
                        key={`longitud${props.row.oid}`}
                        disabled={props.row.locked}
                        autoFocus
                        type='text'
                        onChange={(e: any) => {
                            if (!isNumber(e.target.value)) {
                                props.row.longitud = null;
                            } else {
                                props.row.longitud = Number(e.target.value);
                                props.onRowChange({
                                    ...props.row,
                                    longitud: props.row.longitud,
                                });
                            }
                        }}
                        defaultValue={props.row.longitud}
                    />
                ),
                editorOptions: {
                    editOnClick: true,
                },
            },
        ];
        const columnsVisible = result.filter((obj) => obj.visible === true);
        setColumnsGrid(columnsVisible);
    }

    // const [state, setState] = React.useState({
    //     country: "",
    //     name: "hai",
    // });

    // const customStyles = {
    //     menu: (provided: any, state: any) => ({
    //         ...provided,
    //         width: state.selectProps.width,
    //         borderBottom: "1px dotted pink",
    //         color: state.selectProps.menuColor,
    //         padding: 1,
    //     }),

    //     control: (_: any, { selectProps: { width } }: any) => ({
    //         width: width,
    //     }),

    //     singleValue: (provided: any, state: any) => {
    //         const opacity = state.isDisabled ? 0.5 : 1;
    //         const transition = "opacity 300ms";

    //         return { ...provided, opacity, transition };
    //     },
    // };

    // const handleChange = (event: any) => {
    //     const name = event.target.name;
    //     setState({
    //         ...state,
    //         [name]: event.target.value,
    //     });
    // };

    const handleChangeYear = (event: any) => {
        setCurrentYear(Number(event.target.value));

        loadObras(
            currentProgram,
            event.target.value,
            currentMonth,
            isEdit,
            paises,
            programas,
            tipoObras,
            jefeEquipos,
            monedas,
            estadosEjecucion
        );
    };

    const handleChangeMonth = (event: any) => {
        setCurrentMonth(Number(event.target.value));
        loadObras(
            currentProgram,
            currentYear,
            event.target.value,
            isEdit,
            paises,
            programas,
            tipoObras,
            jefeEquipos,
            monedas,
            estadosEjecucion
        );
    };

    const handleChangeProgram = ({ target }: any) => {
        const { oid } = target.value;
        setCurrentProgram(Number(oid));
        if (oid > 0) {
            setActiveCreateObraButton(true);
            setActiveGuardarObraButton(true);
        }
        loadObras(
            oid,
            currentYear,
            currentMonth,
            isEdit,
            paises,
            programas,
            tipoObras,
            jefeEquipos,
            monedas,
            estadosEjecucion
        );
    };

    const onChangeValue = (data: any) => {};

    function rowKeyGetter(row: ObraApp) {
        return row.oid as number;
    }

    const rowClassName = (data: ObraApp) => {
        if (data.rowClass) {
            return data.rowClass;
        } else return 'global-custom-row';
    };

    const isValidPrograms = (items: ObraApp[]): boolean => {
        setInvalidFields(false);
        setLoading(true);
        let invalid = false;
        let itemsClon = items;
        const countriesInvalids = items.filter((x: ObraApp) => !x.pais);
        const namesInvalids = items.filter((x: ObraApp) => !x.nombre);
        const localCoinInvalids = items.filter((x: ObraApp) => !x.moneda);
        const executeStateInvalids = items.filter((x: ObraApp) => !x.estadoEjecucion);
        // const lastMonthContratistInvalids = items.filter(
        //     (x: ObraApp) => !x.mesUltPagoContratista
        // );

        const teamLeaderInvalids = items.filter((x: ObraApp) => !x.jefeEquipo);

        const finalDateInvalids = items.filter((x: ObraApp) => !x.fechaFinalizacionVigente);
        if (countriesInvalids.length > 0) {
            countriesInvalids.forEach((x, i) => {
                const itemToInvalidate = items.findIndex((j) => j.oid === x.oid);
                itemsClon[itemToInvalidate].invalidCountry = true;
            });
            invalid = true;
        }

        if (namesInvalids.length > 0) {
            namesInvalids.forEach((x, i) => {
                const itemToInvalidate = items.findIndex((j) => j.oid === x.oid);
                itemsClon[itemToInvalidate].invalidName = true;
            });
            invalid = true;
        }

        if (localCoinInvalids.length > 0) {
            localCoinInvalids.forEach((x, i) => {
                const itemToInvalidate = items.findIndex((j) => j.oid === x.oid);
                itemsClon[itemToInvalidate].invalidLocalCoin = true;
            });
            invalid = true;
        }

        if (finalDateInvalids.length > 0) {
            finalDateInvalids.forEach((x, i) => {
                const itemToInvalidate = items.findIndex((j) => j.oid === x.oid);
                itemsClon[itemToInvalidate].invalidFinalDate = true;
            });
            invalid = true;
        }
        if (executeStateInvalids.length > 0) {
            executeStateInvalids.forEach((x, i) => {
                const itemToInvalidate = items.findIndex((j) => j.oid === x.oid);
                itemsClon[itemToInvalidate].invalidExecutionState = true;
            });
            invalid = true;
        }
        // if (lastMonthContratistInvalids.length > 0) {
        //     lastMonthContratistInvalids.forEach((x, i) => {
        //         const itemToInvalidate = items.findIndex(
        //             (j) => j.oid === x.oid
        //         );
        //         itemsClon[itemToInvalidate].invalidLastMonthContratist = true;
        //     });
        //     invalid = true;
        // }
        if (teamLeaderInvalids.length > 0) {
            teamLeaderInvalids.forEach((x, i) => {
                const itemToInvalidate = items.findIndex((j) => j.oid === x.oid);
                itemsClon[itemToInvalidate].invalidTeamLeader = true;
            });
            invalid = true;
        }
        setInvalidFields(invalid);
        setObras(itemsClon);
        setTimeout(() => {
            setLoading(false);
        }, 100);
        return !invalid;
    };

    const saveData = async () => {
        let result: ObraApp[] = [];
        if (!isValidPrograms(obras)) {
            return;
        }
        if (emptyData) {
            result = newObrasForUpdate;
            const today = new Date().getDate();
            const currentDate = new Date(currentYear, currentMonth - 1, today);
            for (let i = 0; i < newObrasForUpdate.length; i++) {
                newObrasForUpdate[i].fecha = currentDate;
                newObrasForUpdate[i].oid = 0;
            }
            const createNotification: NotificationAlert = {
                month: currentMonth,
                year: currentYear,
                notificationDate: new Date(),
                notificationType: General.NotificationType.CreateObra,
                programId: currentProgram,
                statusId: 0,
                paisId: newObrasForUpdate.length > 0 ? newObrasForUpdate[0].pais : null,
            };
            notificationsService.addNotification(createNotification).then((response: any) => {
                obrasService
                    .saveObrasAppTemporales(
                        result.map((ob: ObraApp) => {
                            const obraTemp: ObraAppTemporal = {
                                oidObra: ob.oid!,
                                oid: ob.oid,
                                notificationId: response.data.id,
                                actaSuspencionFirmada: ob.actaSuspencionFirmada,
                                cantidadManoObra: ob.cantidadManoObra,
                                cantidadObreroCesados: ob.cantidadObreroCesados,
                                estadoEjecucion: ob.estadoEjecucion,
                                estadoEjecucionItem: ob.estadoEjecucionItem,
                                fecha: ob.fecha,
                                actaSuspencionMesFirma: ob.actaSuspencionMesFirma,
                                fechaFinalizacionEstimada: ob.fechaFinalizacionEstimada,
                                fechaFinalizacionVigente: ob.fechaFinalizacionVigente,
                                fechaInicio: ob.fechaInicio,
                                flexibilizacionClausulasContractuales:
                                    ob.flexibilizacionClausulasContractuales,
                                jefeEquipo: ob.jefeEquipo,
                                jefeEquipoItem: ob.jefeEquipoItem,
                                latitud: ob.latitud,
                                gcrecord: ob.gcrecord,
                                limitacionActividadesAdministrativas:
                                    ob.limitacionActividadesAdministrativas,
                                index: ob.index,
                                locked: ob.locked,
                                longitud: ob.longitud,
                                longitudKm: ob.longitudKm,
                                mesUltPagoContratista: ob.mesUltPagoContratista,
                                moneda: ob.moneda,
                                monedaItem: ob.monedaItem,
                                montoInicial: ob.montoInicial,
                                montoVigente: ob.montoVigente,
                                nombre: ob.nombre,
                                nota: ob.nota,
                                nuevoCronograma: ob.nuevoCronograma,
                                optimisticLockField: ob.optimisticLockField,
                                orden: ob.orden,
                                pagado: ob.pagado,
                                pagoStockMateriales: ob.pagoStockMateriales,
                                pais: ob.pais,
                                paisItem: ob.paisItem,
                                pendientePorVerificar: ob.pendientePorVerificar,
                                plazoInicialMeses: ob.plazoInicialMeses,
                                porcentajeBid: ob.porcentajeBid ? ob.porcentajeBid : null,
                                porcentajeContrapartida: ob.porcentajeContrapartida
                                    ? ob.porcentajeContrapartida
                                    : null,
                                problemaCadenaSuministros: ob.problemaCadenaSuministros,
                                programItem: ob.programItem,
                                programa: ob.programa,
                                provincia: ob.provincia,
                                sobreCostoEstimado: ob.sobreCostoEstimado,
                                sobreCostoEstimadoNoMaterializado:
                                    ob.sobreCostoEstimadoNoMaterializado,
                                seSuscribioAdenda: ob.seSuscribioAdenda,
                                tipoCambio: ob.tipoCambio,
                                tipoObra: ob.tipoObra,
                                tipoObraItem: ob.tipoObraItem,
                                tramo: ob.tramo,
                                rowClass: ob.rowClass,
                                anoFinalizaciónContrato: ob.anoFinalizaciónContrato,
                                apareceEnBaseDeDatos: ob.apareceEnBaseDeDatos,
                                avanceDePlazoPlazoIntermedio: ob.avanceDePlazoPlazoIntermedio,
                                clasificacionDeSobrecostos: ob.clasificacionDeSobrecostos,
                                clasificacionPorKm: ob.clasificacionPorKm,
                                clasificacionPorMontos: ob.clasificacionPorMontos,
                                clasificacionPorPlazo: ob.clasificacionPorPlazo,
                                clasificacionPorSobreplazo: ob.clasificacionPorSobreplazo,
                                contratista1: ob.contratista1,
                                contratista2: ob.contratista2,
                                contratistaConsorciosObra: ob.contratistaConsorciosObra,
                                desapareceDeBaseDeDatos: ob.desapareceDeBaseDeDatos,
                                empresaSupervisora: ob.empresaSupervisora,
                                estadoDeAvanceGeneral: ob.estadoDeAvanceGeneral,
                                externalIdCaptudata1: ob.externalIdCaptudata1,
                                externalIdcaptudata: ob.externalIdcaptudata,
                                f103: ob.f103,
                                fechaActualizacion: new Date(),
                                fechaDeOrdenDeInicioEnMesAño: ob.fechaDeOrdenDeInicioEnMesAño,
                                fechaRecibioInformación: ob.fechaRecibioInformación,
                                ficConTazasCambioDiferenciadas: ob.ficConTazasCambioDiferenciadas,
                                ficmetodologicoContratosActivos: ob.ficmetodologicoContratosActivos,
                                ficmetodologicoContratosActivosSinCeros:
                                    ob.ficmetodologicoContratosActivosSinCeros,
                                fpcmetodologicoContratosActivos: ob.fpcmetodologicoContratosActivos,
                                fpcmetodologicoContratosActivosSinCeros:
                                    ob.fpcmetodologicoContratosActivosSinCeros,
                                localizacion: ob.localizacion,
                                manoObraPorMontoDeInversionMillones:
                                    ob.manoObraPorMontoDeInversionMillones,
                                mesDelÚltimoPagoAlContratistaEnMesAño:
                                    ob.mesDelÚltimoPagoAlContratistaEnMesAño,
                                montoContractualDolares: ob.montoContractualDolares,
                                montoContractualDolaresEnMillones:
                                    ob.montoContractualDolaresEnMillones,
                                montoContractualInicialEnDólaresConTasaDeCambioPorMes:
                                    ob.montoContractualInicialEnDólaresConTasaDeCambioPorMes,
                                montoContractualVigenteModificadoDolares:
                                    ob.montoContractualVigenteModificadoDolares,
                                montoContractualVigenteModificadoDolaresEnMillones:
                                    ob.montoContractualVigenteModificadoDolaresEnMillones,
                                montoContractualVigenteModificadoDólaresConTasaDeCam:
                                    ob.montoContractualVigenteModificadoDólaresConTasaDeCam,
                                muestraDeChequeo: ob.muestraDeChequeo,
                                nacionalidadContratista: ob.nacionalidadContratista,
                                nacionalidadEmpresaSupervisora: ob.nacionalidadEmpresaSupervisora,
                                notaFinalEstadoGeneral: ob.notaFinalEstadoGeneral,
                                notaFinalSobrecostos: ob.notaFinalSobrecostos,
                                notaFinalSobreplazo: ob.notaFinalSobreplazo,
                                plazoContractualVigente: ob.plazoContractualVigente,
                                plazoContractualVigentePasoIntermedio:
                                    ob.plazoContractualVigentePasoIntermedio,
                                plazoInicialPorKm: ob.plazoInicialPorKm,
                                plazoVigentePorKm: ob.plazoVigentePorKm,
                                ponderadorFicMca: ob.ponderadorFicMca,
                                ponderadorFicMcasinCeros: ob.ponderadorFicMcasinCeros,
                                ponderadorPfc: ob.ponderadorPfc,
                                ponderadorPfcMcasinCeros: ob.ponderadorPfcMcasinCeros,
                                porcentajeAvanceAcumulado: ob.porcentajeAvanceAcumulado
                                    ? ob.porcentajeAvanceAcumulado
                                    : null,
                                porcentajeAvanceDePlazo: ob.porcentajeAvanceDePlazo
                                    ? ob.porcentajeAvanceDePlazo
                                    : null,
                                precioInicialPorKmMillones: ob.precioInicialPorKmMillones,
                                precioVigentePorKmMillones: ob.precioVigentePorKmMillones,
                                sobrecostosMaterializados: ob.sobrecostosMaterializados,
                                sobrecostosUsd: ob.sobrecostosUsd,
                                sobrecostosUsdenMillones: ob.sobrecostosUsdenMillones,
                                sobreplazoMesesCalculado: ob.sobreplazoMesesCalculado,
                                subRegion: ob.subRegion,
                                supervisora1: ob.supervisora1,
                                tipoCambioPorMesYmoneda: ob.tipoCambioPorMesYmoneda,
                                tipoDeCambioPorMesYMonedaSegúnFechaDeInicioDeObras:
                                    ob.tipoDeCambioPorMesYMonedaSegúnFechaDeInicioDeObras,
                                tipoDeCambioPorMesYMonedaSegúnMesDePagoAContratista:
                                    ob.tipoDeCambioPorMesYMonedaSegúnMesDePagoAContratista,
                                totalPagoHastaLaFechaDolares: ob.totalPagoHastaLaFechaDolares,
                                _: ob._,
                                _2020: ob._2020,
                                _2021: ob._2021,
                                _2022: ob._2022,
                                _2023: ob._2023,
                                _2024: ob._2024,
                                _2025: ob._2025,

                                // validators
                                invalidCountry: false,
                                invalidName: false,
                                invalidLocalCoin: false,
                                invalidInitialAmount: false,
                                invalidCurrentAmount: false,
                                invalidFinalDate: false,
                                invalidPayed: false,
                                invalidExecutionState: false,
                                invalidTeamLeader: false,
                            };
                            return obraTemp;
                        })
                    )
                    .then((obrasRes: any) => {
                        setSuccessSaved(true);
                        setTimeout(() => {
                            window.location.href = '/update-data';
                        }, 200);
                    });
            });
        } else {
            result = obras;
            const notification: NotificationAlert = {
                month: currentMonth,
                year: currentYear,
                notificationDate: new Date(),
                notificationType: General.NotificationType.UpdateProjects,
                programId: currentProgram,
                statusId: 0,
                paisId: obras.length > 0 ? obras[0].pais : null,
            };
            notificationsService.addNotification(notification).then((response: any) => {
                obrasService
                    .saveObrasAppTemporales(
                        result.map((ob: ObraApp) => {
                            const obraTemp: ObraAppTemporal = {
                                oidObra: ob.oid!,
                                notificationId: response.data.id,
                                actaSuspencionFirmada: ob.actaSuspencionFirmada,
                                cantidadManoObra: ob.cantidadManoObra,
                                cantidadObreroCesados: ob.cantidadObreroCesados,
                                estadoEjecucion: ob.estadoEjecucion,
                                estadoEjecucionItem: ob.estadoEjecucionItem,
                                fecha: ob.fecha,
                                actaSuspencionMesFirma: ob.actaSuspencionMesFirma,
                                fechaFinalizacionEstimada: ob.fechaFinalizacionEstimada,
                                fechaFinalizacionVigente: ob.fechaFinalizacionVigente,
                                fechaInicio: ob.fechaInicio,
                                flexibilizacionClausulasContractuales:
                                    ob.flexibilizacionClausulasContractuales,
                                jefeEquipo: ob.jefeEquipo,
                                jefeEquipoItem: ob.jefeEquipoItem,
                                latitud: ob.latitud,
                                gcrecord: ob.gcrecord,
                                limitacionActividadesAdministrativas:
                                    ob.limitacionActividadesAdministrativas,
                                index: ob.index,
                                locked: ob.locked,
                                longitud: ob.longitud,
                                longitudKm: ob.longitudKm,
                                mesUltPagoContratista: ob.mesUltPagoContratista,
                                moneda: ob.moneda,
                                monedaItem: ob.monedaItem,
                                montoInicial: ob.montoInicial,
                                montoVigente: ob.montoVigente,
                                nombre: ob.nombre,
                                nota: ob.nota,
                                nuevoCronograma: ob.nuevoCronograma,
                                optimisticLockField: ob.optimisticLockField,
                                orden: ob.orden,
                                pagado: ob.pagado,
                                pagoStockMateriales: ob.pagoStockMateriales,
                                pais: ob.pais,
                                paisItem: ob.paisItem,
                                pendientePorVerificar: ob.pendientePorVerificar,
                                plazoInicialMeses: ob.plazoInicialMeses,
                                porcentajeBid: ob.porcentajeBid ? ob.porcentajeBid : null,
                                porcentajeContrapartida: ob.porcentajeContrapartida
                                    ? ob.porcentajeContrapartida
                                    : null,
                                problemaCadenaSuministros: ob.problemaCadenaSuministros,
                                programItem: ob.programItem,
                                programa: ob.programa,
                                provincia: ob.provincia,
                                sobreCostoEstimado: ob.sobreCostoEstimado,
                                sobreCostoEstimadoNoMaterializado:
                                    ob.sobreCostoEstimadoNoMaterializado,
                                seSuscribioAdenda: ob.seSuscribioAdenda,
                                tipoCambio: ob.tipoCambio,
                                tipoObra: ob.tipoObra,
                                tipoObraItem: ob.tipoObraItem,
                                tramo: ob.tramo,
                                rowClass: ob.rowClass,
                                anoFinalizaciónContrato: ob.anoFinalizaciónContrato,
                                apareceEnBaseDeDatos: ob.apareceEnBaseDeDatos,
                                avanceDePlazoPlazoIntermedio: ob.avanceDePlazoPlazoIntermedio,
                                clasificacionDeSobrecostos: ob.clasificacionDeSobrecostos,
                                clasificacionPorKm: ob.clasificacionPorKm,
                                clasificacionPorMontos: ob.clasificacionPorMontos,
                                clasificacionPorPlazo: ob.clasificacionPorPlazo,
                                clasificacionPorSobreplazo: ob.clasificacionPorSobreplazo,
                                contratista1: ob.contratista1,
                                contratista2: ob.contratista2,
                                contratistaConsorciosObra: ob.contratistaConsorciosObra,
                                desapareceDeBaseDeDatos: ob.desapareceDeBaseDeDatos,
                                empresaSupervisora: ob.empresaSupervisora,
                                estadoDeAvanceGeneral: ob.estadoDeAvanceGeneral,
                                externalIdCaptudata1: ob.externalIdCaptudata1,
                                externalIdcaptudata: ob.externalIdcaptudata,
                                f103: ob.f103,
                                fechaActualizacion: new Date(),
                                fechaDeOrdenDeInicioEnMesAño: ob.fechaDeOrdenDeInicioEnMesAño,
                                fechaRecibioInformación: ob.fechaRecibioInformación,
                                ficConTazasCambioDiferenciadas: ob.ficConTazasCambioDiferenciadas,
                                ficmetodologicoContratosActivos: ob.ficmetodologicoContratosActivos,
                                ficmetodologicoContratosActivosSinCeros:
                                    ob.ficmetodologicoContratosActivosSinCeros,
                                fpcmetodologicoContratosActivos: ob.fpcmetodologicoContratosActivos,
                                fpcmetodologicoContratosActivosSinCeros:
                                    ob.fpcmetodologicoContratosActivosSinCeros,
                                localizacion: ob.localizacion,
                                manoObraPorMontoDeInversionMillones:
                                    ob.manoObraPorMontoDeInversionMillones,
                                mesDelÚltimoPagoAlContratistaEnMesAño:
                                    ob.mesDelÚltimoPagoAlContratistaEnMesAño,
                                montoContractualDolares: ob.montoContractualDolares,
                                montoContractualDolaresEnMillones:
                                    ob.montoContractualDolaresEnMillones,
                                montoContractualInicialEnDólaresConTasaDeCambioPorMes:
                                    ob.montoContractualInicialEnDólaresConTasaDeCambioPorMes,
                                montoContractualVigenteModificadoDolares:
                                    ob.montoContractualVigenteModificadoDolares,
                                montoContractualVigenteModificadoDolaresEnMillones:
                                    ob.montoContractualVigenteModificadoDolaresEnMillones,
                                montoContractualVigenteModificadoDólaresConTasaDeCam:
                                    ob.montoContractualVigenteModificadoDólaresConTasaDeCam,
                                muestraDeChequeo: ob.muestraDeChequeo,
                                nacionalidadContratista: ob.nacionalidadContratista,
                                nacionalidadEmpresaSupervisora: ob.nacionalidadEmpresaSupervisora,
                                notaFinalEstadoGeneral: ob.notaFinalEstadoGeneral,
                                notaFinalSobrecostos: ob.notaFinalSobrecostos,
                                notaFinalSobreplazo: ob.notaFinalSobreplazo,
                                plazoContractualVigente: ob.plazoContractualVigente,
                                plazoContractualVigentePasoIntermedio:
                                    ob.plazoContractualVigentePasoIntermedio,
                                plazoInicialPorKm: ob.plazoInicialPorKm,
                                plazoVigentePorKm: ob.plazoVigentePorKm,
                                ponderadorFicMca: ob.ponderadorFicMca,
                                ponderadorFicMcasinCeros: ob.ponderadorFicMcasinCeros,
                                ponderadorPfc: ob.ponderadorPfc,
                                ponderadorPfcMcasinCeros: ob.ponderadorPfcMcasinCeros,
                                porcentajeAvanceAcumulado: ob.porcentajeAvanceAcumulado
                                    ? ob.porcentajeAvanceAcumulado
                                    : null,
                                porcentajeAvanceDePlazo: ob.porcentajeAvanceDePlazo
                                    ? ob.porcentajeAvanceDePlazo
                                    : null,
                                precioInicialPorKmMillones: ob.precioInicialPorKmMillones,
                                precioVigentePorKmMillones: ob.precioVigentePorKmMillones,
                                sobrecostosMaterializados: ob.sobrecostosMaterializados,
                                sobrecostosUsd: ob.sobrecostosUsd,
                                sobrecostosUsdenMillones: ob.sobrecostosUsdenMillones,
                                sobreplazoMesesCalculado: ob.sobreplazoMesesCalculado,
                                subRegion: ob.subRegion,
                                supervisora1: ob.supervisora1,
                                tipoCambioPorMesYmoneda: ob.tipoCambioPorMesYmoneda,
                                tipoDeCambioPorMesYMonedaSegúnFechaDeInicioDeObras:
                                    ob.tipoDeCambioPorMesYMonedaSegúnFechaDeInicioDeObras,
                                tipoDeCambioPorMesYMonedaSegúnMesDePagoAContratista:
                                    ob.tipoDeCambioPorMesYMonedaSegúnMesDePagoAContratista,
                                totalPagoHastaLaFechaDolares: ob.totalPagoHastaLaFechaDolares,
                                _: ob._,
                                _2020: ob._2020,
                                _2021: ob._2021,
                                _2022: ob._2022,
                                _2023: ob._2023,
                                _2024: ob._2024,
                                _2025: ob._2025,

                                // validators
                                invalidCountry: false,
                                invalidName: false,
                                invalidLocalCoin: false,
                                invalidInitialAmount: false,
                                invalidCurrentAmount: false,
                                invalidFinalDate: false,
                                invalidPayed: false,
                                invalidExecutionState: false,
                                invalidTeamLeader: false,
                            };
                            return obraTemp;
                        })
                    )
                    .then((obrasRes: any) => {
                        setSuccessSaved(true);
                        setTimeout(() => {
                            window.location.href = '/update-data';
                        }, 200);
                    });
            });
        }
    };

    return (
        <section id='create' className='bg-gray'>
            <div className='container cont-in'>
                {isUpdated ? (
                    <h3>Crear proyectos avanzados</h3>
                ) : (
                    <h3>Editar proyectos avanzados</h3>
                )}
                <br />
                <div className='row'>
                    <div className='col-12 col-md-4'>
                        <p>
                            <b>Programa:</b>{' '}
                        </p>
                        <DropDownList
                            disabled={isEdit}
                            data={programas || []}
                            textField='descripcion'
                            dataItemKey='oid'
                            onChange={handleChangeProgram}
                            defaultValue={programSelected.value}></DropDownList>
                    </div>
                    <div className='col-12 col-md-8'>
                        {/* <p className="text-center">Periodo: </p> */}
                        <div className='d-flex'>
                            <div className='col-12 col-md-6'>
                                <p>
                                    <b> Año:</b>{' '}
                                </p>
                                <DropDownList
                                    disabled={false}
                                    data={years()}
                                    onChange={handleChangeYear}
                                    defaultValue={currentYear}></DropDownList>
                            </div>
                            <div className='col-12 col-md-6'>
                                <p>
                                    <b> Mes:</b>{' '}
                                </p>
                                <DropDownList
                                    disabled={isEdit}
                                    data={months()}
                                    onChange={handleChangeMonth}
                                    defaultValue={currentMonth}></DropDownList>
                            </div>
                        </div>
                    </div>
                </div>
                {activeCreateObraButton && (
                    <div className='boton--crear--obra'>
                        <Link
                            className='link--to--country'
                            to={`/create-program/${currentProgram}/${currentYear}/${currentMonth}`}>
                            <button className='btn-obra'>Crear Obra</button>
                        </Link>
                    </div>
                )}
                <div className='row'>
                    <div className='col-12'>
                        {columnsGrid && obras && (
                            <ReactDataGrid
                                columns={columnsGrid}
                                rows={obras}
                                onRowsChange={setObras}
                                headerRowHeight={100}
                                rowKeyGetter={rowKeyGetter}
                                rowClass={rowClassName}
                                className='dataGridContainer'
                            />
                        )}
                    </div>
                </div>
                {loading && (
                    <div className='loading'>
                        <Loading />
                    </div>
                )}
                <div className='row'>
                    <div className='col-12'>
                        {columns && obras && !loading && (
                            <DataSheetGrid
                                headerRowHeight={120}
                                rowHeight={120}
                                height={1600}
                                value={obras}
                                autoAddRow={true}
                                onChange={onChangeValue}
                                columns={columns}
                            />
                        )}
                    </div>
                </div>
                {successSaved && (
                    <div className='row mt-3'>
                        <div className='container'>
                            <div className='alert alert-success' role='alert'>
                                Los cambios fueron guardados satisfactoriamente
                            </div>
                        </div>
                    </div>
                )}
                {invalidFields && (
                    <div className='row mt-3'>
                        <div className='container'>
                            <div className='alert alert-danger' role='alert'>
                                Faltan campos por llenar
                            </div>
                        </div>
                    </div>
                )}
                {activeGuardarObraButton && (
                    <div className='row justify-content-end'>
                        <div className='col-12 col-md-3 mt-3'>
                            <button className='btn-pjt' onClick={(e) => saveData()}>
                                Guardar
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
}
